<div class="search-filters__wrapper" *ngIf="isLoad"> 
  <div class="row">
    <div class="col-md-2 col-6" *ngFor="let filter of filters">
      <div class="search-filters">
        <p class="dropdown-label text-center">{{ filter.label }}</p> <br>
        <div class="dropdown sort-by">
          <div class="select-coontainer">
            <select name="filter" [id]="filter.name" class="form-control select-box" (change)="onFilterChange()"
              [(ngModel)]="filter.selectedValue">
              <option [value]=null>Select </option>
              <option *ngFor="let option of filter.options" [value]="option">{{ option }}</option>
            </select>
            <div class="icon-container">
              <i class="fas fa-angle-down"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>